import { render, staticRenderFns } from "./create-send-list.vue?vue&type=template&id=1ddd98b4&scoped=true"
import script from "./create-send-list.vue?vue&type=script&lang=js"
export * from "./create-send-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ddd98b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ddd98b4')) {
      api.createRecord('1ddd98b4', component.options)
    } else {
      api.reload('1ddd98b4', component.options)
    }
    module.hot.accept("./create-send-list.vue?vue&type=template&id=1ddd98b4&scoped=true", function () {
      api.rerender('1ddd98b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/conversations/send-list/create-send-list.vue"
export default component.exports